@if (selfserviceStarted()) {
  <div class="selfservice-status__container">
    <span>
      Selfservice <span class="selfservice-started">{{ "Global.Authorized" | translate | lowercase }}</span>
    </span>
    <span class="selfservice-status__row access">
      <svg-icon src="assets/images/icons/lock.svg" class="selfservice-started__icon"></svg-icon>
      <span>{{ tokenValidFor() | formatduration }}</span>
    </span>
  </div>
} @else {
  <div class="selfservice-status__container">
    <span class="notstarted">
      <strong>{{ "Global.AuthenticationNeeded" | translate }}</strong>
      {{ "Global.AuthenticationNeededText" | translate }}
    </span>
    <span (click)="startSelfService()" class="selfservice-status__row noaccess">
      <svg-icon src="assets/images/icons/lock.svg" class="selfservice-not-started__icon"></svg-icon>
      <span>{{ "ShortcutMenu.SelfService" | translate }}</span>
    </span>
  </div>
}
